module.exports = "/_next/static/images/Hero-39b76d3e020036912eb5c3ab279dcc0f.webp";